import { Injectable } from "@angular/core";
// Translate
import { TranslateService } from "@ngx-translate/core";
// Own services
import { ToastService } from "./ToastService.service";

/** Displays support contact details in an info alert, using custom URL footer values when available. */
@Injectable({
  providedIn: "root"
})
export class ContactService {
  constructor(
    private readonly ToastService: ToastService,
    private readonly translate: TranslateService
  ) {}

  // Show contact panel
  showContact(customData: any): void {
    this.ToastService.fireAlertInfoText(
      "info",
      this.translate.instant("contact"),
      ` <div class="contact` +
        (customData ? ` contact-full-width` : `"`) +
        `">` +
        (customData
          ? customData.footerContactPhoto
          : `<img class="contact-ccd" src="../../../../assets/img/ccd/ccd.jpg" />`) +
        `<div>
            <div>
              <span><i class="fas fa-at"></i>
                <a href="` +
        (customData ? customData.footerContactLink : "mailto:soporte@arsondata.com") +
        `" target="_blank">` +
        (customData ? customData.footerContactLink : "soporte@arsondata.com") +
        `</a>
              </span>
              <span><i class="fas fa-phone-alt"></i>` +
        (customData ? customData.footerContactTel : "+34 94 683 50 37") +
        `</span>
            </div>` +
        (customData
          ? ""
          : `<div>
              <span><i class="fab fa-whatsapp"></i><a href="https://wa.me/message/4CZHZ22LNJYQG1">CCD ARSON</a></span>
              <img src="../../../../assets/img/ccd/ccd_whatsapp.png" />
            </div>`) +
        ` </div>
        </div>`
    );
  }
}
